/**
 * 2026-05-29 · Fresh-start cache clear on access-code redeem.
 *
 * When a rep redeems an access code their account is (re)entering fresh — the
 * apology reset cleared their server-side wedge_prefs / wedge_outcomes /
 * wedge_saved. But the DEVICE still caches the prior session: the
 * onboarding-complete flag, Rep XP, streak, the prefs profile, learned
 * patterns, and every coachmark "seen" flag. That cache makes the app skip
 * onboarding and rehydrate the old session (Luke's 2026-05-29 test: tapped a
 * fresh code, got dropped back into "Lvl 1 BEV · 760 XP" instead of a clean
 * re-onboard).
 *
 * Clearing the wedge-namespaced localStorage on redeem forces a true fresh
 * start: no server prefs + no local onboarding flag => onboarding runs.
 *
 * Preserves the theme preference and the device auth tag. The session itself
 * lives in httpOnly cookies, so this never signs anyone out. Auth/region keys
 * are `territory_crm_*` and are deliberately untouched.
 */
export function clearWedgeLocalState(): void {
  try {
    const KEEP = new Set(['rv_wedge_device', 'rv_wedge_theme_pref']);
    /* 'wedge_' (bare, no dot) covers wedge_accounts_cache (up to 1.5MB of the
       rep's CRM book), wedge_no_crm_book, wedge_cal_not_linked_at and
       wedge_siri_added · all previously survived every wipe because only the
       dotted 'wedge.' prefix was listed. */
    const PREFIXES = ['rv_wedge_', 'repvantage.wedge', 'wedge.', 'wedge_', 'deck-stage.'];
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k || KEEP.has(k)) continue;
      if (PREFIXES.some((p) => k.startsWith(p))) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* storage blocked (private mode) — nothing to clear, app falls back to server prefs */
  }
}
